import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { LoadingPageModule } from "../loading-page/loading-page.module";
import { ModalHeaderComponent } from "../modal-header/modal-header.component";
import { BannerSlidesComponent } from "../banner-slides/banner-slides.component";
import { MatCheckboxChange } from '@angular/material/checkbox';
import { IBannerSlide } from '../banner-slides/contracts/interfaces/banner-slide.interface';
import { ModalComunicadoService } from './modal-comunicado.service';

@Component({
  selector: 'app-modal-comunicado',
  templateUrl: './modal-comunicado.component.html',
  styleUrls: ['./modal-comunicado.component.scss'],
  imports: [LoadingPageModule, ModalHeaderComponent, BannerSlidesComponent],
})
export class ModalComunicadoComponent implements OnInit {
  public modalRef = inject(DialogRef<ModalComunicadoComponent>);
  public slidesData = inject<IBannerSlide[]>(DIALOG_DATA);
  private modalComunicadoService = inject(ModalComunicadoService)
        
  public currentSlide = 0;

  private communicationViewed!: {id: string, viewed: boolean};

  @ViewChild('player') player!: ElementRef<HTMLIFrameElement>;

  ngOnInit(): void {
    this.listenModalClosure();
  }

  changeCommunicationViewed(event: MatCheckboxChange) {
    this.communicationViewed = {
      viewed: event.checked,
      id: this.slidesData[this.currentSlide].Id
    };
  }
  
  changeCommunicationViewedByLink(id: string) {
    this.communicationViewed = {
      viewed: true,
      id: this.slidesData[this.currentSlide].Id
    };

    this.setCommunicationViewed();
    this.closeModal();
  }

  currentSlideChange(currentSlideIndex: number) {    
    this.currentSlide = currentSlideIndex;
  }

  closeModal() {    
    this.modalRef.close()
  }

  setCommunicationViewed() {
    if (this.communicationViewed) {
      this.modalComunicadoService.setViewed(this.communicationViewed.id)
    }
  }

  listenModalClosure() {
    this.modalRef.closed.subscribe(() => {
      this.setCommunicationViewed();
    })
  }
}
